import React from 'react';
import Header from '../../../components/Common/Header/Header';
import ContentApp from '../../../components/ContentApp';
import FixedButton from '../../../components/Common/FixedButton/FixedButton';
import Button from '../../../components/Common/Button/Button';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styles from '../reservation.module.css';
import SuccessCheck from '../../../components/icons/SuccessCheck';

const ReservationSuccessCourtesy = ({ history }) => {
  const { t } = useTranslation();
  const showName = useSelector((state) => state.reservation.showName);

  return (
    <>
      <Header showBack={false} title={showName} />
      <ContentApp classes={'pt-0'}>
        <div className={`d-flex align-items-center justify-content-center ${styles.iconContainer}`}>
          <SuccessCheck color={'var(--color-primary)'} size='135px' />
        </div>
        <div className='mt-5 pt-3 px-3'>
          <div className={`bold text-left font-large ${styles.title}`}>
            {t('courtesyTicketsSuccess.title')}
          </div>
          <div className='text-secondary semi-bold font-normal text-left mt-3'>
            {t('courtesyTicketsSuccess.description')}
          </div>
        </div>
        <FixedButton>
          <Button
            text={t('returnHome')}
            size='large'
            className={`mt-2 btn-primary`}
            onClick={() => history.push('/')}
            icon={true}
            typeIcon='arrow'
            iconColor='#000'
          />
        </FixedButton>
      </ContentApp>
    </>
  );
};

export default ReservationSuccessCourtesy;
